import { useContext, useEffect } from 'react'
import { ModalContext } from '@nv/contexts'
import CircleCheckIcon from '@nv/images/design/circle-check-icon'
import { useTranslation } from 'react-i18next'
import styles from './RegisterSuccess.module.scss'

export const RegisterSuccess = ({ onClick, autoApproved }) => {
  const { t } = useTranslation()
  const { setHeaderLabel, setBtns } = useContext(ModalContext)

  useEffect(() => {
    setHeaderLabel(t('registration.successfullyRegistered'))
    setBtns([{ text: t('buttons.ok'), onClick: onClick }])
  }, [])

  return (
    <div className={styles['container']}>
      <CircleCheckIcon style={{ width: '200px', height: '100px' }} />
      <div className={styles['text']}>
        {!autoApproved ? t('registration.successfullyRegisteredDescription') : t('registration.successfullyRegisteredApprovedDescription')}
      </div>
    </div>
  )
}
